export default {
  title: {
    id: 'dashboard_menu_bm_pro_info_block_title',
    defaultMessage: 'Shopping for your business?',
  },
  subtitle: {
    id: 'dashboard_menu_bm_pro_info_block_subtitle',
    defaultMessage:
      'Check out our dedicated services for enterprises including B2B invoices, VAT exemption and much more – all on Back Market Pro.',
  },
  cta: {
    id: 'dashboard_menu_bm_pro_info_block_cta',
    defaultMessage: 'Go to Back Market Pro',
  },
}
